module.exports = __webpack_public_path__ + "static/media/YM09_1.b5251dd0.jpg";